import Vue from 'vue'
import VueRouter from 'vue-router'
import MainPage from '@/layout/MainPage'
import AdminMain from '@/layout/AdminMain'

Vue.use(VueRouter)

const basicRoutes = [
  {
    path: '/',
    name: 'index',
    component: MainPage,
    redirect: 'index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/home/home'),
        name: '首页',
        meta: { title: '首页', requiresAuth: false }
      }
    ]
  },
  {
    path: '/product',
    name: 'product',
    component: MainPage,
    redirect: 'product',
    children: [
      {
        path: '',
        component: () => import('@/views/product/product'),
        name: '产品设备',
        meta: { title: '产品设备', requiresAuth: false }
      },
      {
        path: ':id',
        component: () => import('@/views/product/ProductDetail'),
        name: '产品详情',
        meta: { title: '产品介绍', requiresAuth: false }
      }
    ]
  },
  {
    path: '/download',
    name: 'download',
    component: MainPage,
    redirect: 'download',
    children: [
      {
        path: '',
        component: () => import('@/views/download/download'),
        name: '资料下载',
        meta: { title: '资料下载', requiresAuth: false }
      }
    ]
  },
  {
    path: '/about',
    name: 'about',
    component: MainPage,
    redirect: 'about',
    children: [
      {
        path: '',
        component: () => import('@/views/about/about'),
        name: '关于我们',
        meta: { title: '关于我们', requiresAuth: false }
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/layout/Login'),
    meta: { title: '登录', requiresAuth: false }
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/Page404/Page404'),
    meta: { title: '404', requiresAuth: false }
  }
]

const adminRouter = [
  {
    path: '/administration',
    component: AdminMain,
    redirect: 'administration/index',
    children: [
      {
        path: 'index',
        name: '控制台首页',
        component: () => import('@/views/AdminIndex/AdminIndex'),
        meta: { title: '控制台首页', requiresAuth: true }
      },
      {
        path: 'users',
        name: '用户管理',
        component: () => import('@/views/AdminUsers/AdminUsers'),
        meta: { title: '用户管理', requiresAuth: true }
      },
      {
        path: 'product',
        name: '产品管理',
        component: () => import('@/views/AdminProduct/AdminProduct'),
        meta: { title: '产品管理', requiresAuth: true }
      },
      {
        path: 'download',
        name: '下载管理',
        component: () => import('@/views/AdminDownload/AdminDownload'),
        meta: { title: '下载管理', requiresAuth: true }
      },
      {
        path: 'about',
        name: '公司信息管理',
        component: () => import('@/views/AdminAbout/AdminAbout'),
        meta: { title: '公司信息管理', requiresAuth: true }
      }
    ]
  }
]

const route404 = {
  path: '*',
  redirect: '/404'
}

export default new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  // scrollBehavior: () => ({ y: 0 }),
  routes: [ ...basicRoutes, ...adminRouter, route404 ] // 404一定要放在最后
})
